<h2 mat-dialog-title>Before proceeding to the next step, please download or email the quote document</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onDownload()">Download Quote</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onEmail()">Email Quote</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>

